import Vue from 'vue'

function success(msg, options) {
  Vue.toasted.success(msg, options)
}

function error(msg) {
  Vue.toasted.error(msg)
}

export default { success, error }
